/**
 * @file DevicePreview.tsx
 * @module DevicePreview
 * @description
 *   Mount point for the Device Preview tab. Guards rendering behind
 *   isDevicePreviewAvailable from navigation context.
 */

import { useDevicePreviewNavigation } from './DevicePreviewNavigationContext';
import { DevicePreviewErrorBoundary } from './DevicePreviewErrorBoundary';
import { DevicePreviewContent } from './DevicePreviewContent';

export const DevicePreview = () => {
  const { isDevicePreviewAvailable } = useDevicePreviewNavigation();

  if (!isDevicePreviewAvailable) return null;

  return (
    <DevicePreviewErrorBoundary>
      <DevicePreviewContent />
    </DevicePreviewErrorBoundary>
  );
};
